import React, { useState } from 'react';
import { DeleteBlockWarningDialog } from './DeleteBlockWarningDialog';
import { TertiaryButton } from 'system/base/Button';
export type DeleteBlockProps = {
  hasBeenPublishedBefore: boolean;
  onRemove: () => void;
};

export function DeleteBlock({
  onRemove,
  hasBeenPublishedBefore,
}: DeleteBlockProps): JSX.Element {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleConfirm = () => {
    closeModal();
    onRemove();
  };

  const handleDeleteClick = () => {
    if (hasBeenPublishedBefore) {
      openModal();
    } else {
      // No warning needed if the template hasn't been
      // published yet (no data loss risk)
      onRemove();
    }
  };

  return (
    <>
      <DeleteBlockWarningDialog
        isOpen={isModalOpen}
        onConfirm={handleConfirm}
        onDismiss={closeModal}
      />
      <TertiaryButton onClick={handleDeleteClick}>Delete</TertiaryButton>
    </>
  );
}
